<template>
  <div class="card questions">
    <div class="card-header">
      <h3 class="card-title">{{ $t('page.title.player') }} <span v-if="player">{{player.firstName}} {{player.lastName}} ({{player.email}})</span></h3>
      <div class="float-right">
      <router-link :to="{ name: $route.name === 'player-kyc' ? 'players-kyc' : 'player-list' }"><b-button size="sm" variant="outline-primary">{{ $t('btn.back_to_player_list') }}</b-button>
      </router-link>
    </div>
    </div>
    <div class="card-body">
      <b-card no-body>
        <b-tabs card>
          <!-- Add your b-tab components here -->
          <template #tabs-end>
            <b-nav-item  :active="$route.name === 'player-details'"
                         @click="goToPage('player-details')">
              {{$t('player.details.tab.overview')}}</b-nav-item>

            <b-nav-item  :active="$route.name === 'player-kyc'"
                         @click="goToPage('player-kyc')">
              {{$t('player.details.tab.kyc')}}</b-nav-item>

            <b-nav-item :active="$route.name === 'player-wallets'"
                        @click="goToPage('player-wallets')">
              {{$t('player.details.tab.wallets_history')}}</b-nav-item>

            <b-nav-item :active="$route.name === 'player-transactions'"
                        @click="goToPage('player-transactions')">
              {{$t('player.details.tab.transactions_history')}}</b-nav-item>

            <b-nav-item :active="$route.name === 'player-game-history'"
                        @click="goToPage('player-game-history')">
              {{$t('player.details.tab.game_history')}}</b-nav-item>

            <b-nav-item :active="$route.name === 'player-login-history'"
                        @click="goToPage('player-login-history')">
              {{$t('player.details.tab.login_history')}}</b-nav-item>

            <b-nav-item :active="$route.name === 'player-notes'"
                        @click="goToPage('player-notes')">
              {{$t('player.details.tab.notes')}}</b-nav-item>

            <b-nav-item :active="$route.name === 'player-messages'"
                        @click="goToPage('player-messages')">
              {{$t('player.details.tab.messages')}}</b-nav-item>

            <b-nav-item :active="$route.name === 'player-statistics'"
                        @click="goToPage('player-statistics')">
              {{$t('player.details.player-statistics')}}</b-nav-item>
          </template>
          <template #default>
            <div class="tab-pane active card-body">
              <router-view></router-view>
            </div>
          </template>
        </b-tabs>
      </b-card>
    </div>
  </div>
</template>

<script>

export default {
  props: ['apiKey'],
  components: {
  },
  data() {
    return {
      activeTab: '',
      playerId: null
    };
  },
  mounted() {
    this.getPlayer();
  },
  computed: {
    player: function () {
      return this.$store.getters["players/player"];
    },
  },
  beforeDestroy() {
    this.$store.commit('players/setPlayerData', null);
  },
  created() {
    this.playerId = this.$route.params.id;
  },
  methods: {
    goToPage(name) {
      this.$router.push({name: name, params: {id: this.playerId}});
    },
    setActiveTab(value) {
      this.activeTab = value;
    },
    getPlayer() {
      this.$store.dispatch('players/getPlayer', this.playerId);
      this.$store.dispatch('players/getPlayerWallet', this.playerId);
    },
  },
  watch: {
    $route() {
      // this.getPlayer();
    }
  }
}
</script>
